// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".VLink_section_2ndZh{display:grid;padding:15px 18px;color:var(--supster-secondary);cursor:pointer;transition:opacity .3s}.VLink_section_2ndZh:hover{opacity:.6}.VLink_section_2ndZh.VLink_shadow_DAduk{box-shadow:inset 0 -1px 0 #e5e3e3}.VLink_section_2ndZh.VLink_disabled_1Ihnb{cursor:not-allowed}.VLink_section_2ndZh.VLink_disabled_1Ihnb:hover{opacity:1}.VLink_container_1BTac{display:grid;grid-template-columns:1fr auto;-moz-column-gap:9px;column-gap:9px}.VLink_container_1BTac.VLink_disabled_1Ihnb{cursor:not-allowed;opacity:.3}.VLink_icon_3fsmZ{align-self:center;fill:var(--supster-secondary)}.VLink_icon_3fsmZ.VLink_sm_p1YIL{width:3px;height:6px}.VLink_icon_3fsmZ.VLink_md_9UbcW{width:5px;height:8px}.VLink_icon_3fsmZ.VLink_lg_2fkz4{width:5.5px;height:10px}.VLink_icon_3fsmZ.VLink_xl_2_YZe{width:6px;height:12px}", ""]);
// Exports
exports.locals = {
	"section": "VLink_section_2ndZh",
	"shadow": "VLink_shadow_DAduk",
	"disabled": "VLink_disabled_1Ihnb",
	"container": "VLink_container_1BTac",
	"icon": "VLink_icon_3fsmZ",
	"sm": "VLink_sm_p1YIL",
	"md": "VLink_md_9UbcW",
	"lg": "VLink_lg_2fkz4",
	"xl": "VLink_xl_2_YZe"
};
module.exports = exports;
